import { Text, type TextProps } from "@chakra-ui/react";

export function EmptyText({ children, ...rest }: TextProps) {
  return (
    <Text {...rest} color={"gray.400"} fontWeight={400}>
      {children}
    </Text>
  );
}
